import { desktopBreakpoint, mobileBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'

export const Container = styled.section`
    margin: 0 auto;
    max-width: 87.5rem;
    overflow: hidden;
    padding: 1rem 0 0.5rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`
export const InnerContainer = styled.div`
    margin: 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0 auto;
    }
`

export const SliderContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    max-width: fit-content;
    overflow: hidden;
    margin-top: 1rem;
`

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => (!!margin ? margin : 0)};
    li {
        list-style: none;
    }
    ${({ center }) =>
        center
            ? `& > .carousel__slider {
            padding-left: 1rem;
            padding-right: 1rem;

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                padding: 0 1.5rem;
            }
        }`
            : ''}
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        padding: 0;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }
    `,
)

export const SortOptionsContainer = styled.div``

export const MobileSortOverrides = styled.div`
    margin-top: 1rem;

    @media only screen and (max-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem;

        .sort-option-container,
        [class*='sort'],
        [class*='Sort'] {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            overflow-x: auto !important;
            overflow-y: hidden !important;

            scrollbar-width: none !important; /* Firefox */
            -ms-overflow-style: none !important; /* IE and Edge */

            > * {
                flex-shrink: 0 !important;
                white-space: nowrap !important;
                margin-right: ${props => props.theme.spacing.xxSmall} !important;
                margin-bottom: 0 !important;
            }

            > *:last-child {
                margin-right: 0 !important;
            }
        }
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        padding: 0 1rem;
        margin-top: 0.5rem;
    }
`

export const AccommodationsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${props => props.theme.spacing.medium};
    margin-top: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 1.5rem;
    }
`
